import useTranslation from "next-translate/useTranslation";
import { pluralOf } from "pagesHelpers/ListingPagesHepler/HeadSeoHelper";

export const titlePrefix = (
  transaction_type: "Vente" | "Location" | "Projets Neufs" | "",
  bienType: (
    | "Appartement"
    | "Villa"
    | "Terrain"
    | "Commerce"
    | "Bureau"
    | "Maison"
    | "Villas"
    | "Appartements"
    | "Lots de terrains"
    | "Riad"
    | "Local Industriel"
    | string
  )[],
  t?: any,
  vendu?: boolean,
) => {
  if (!t) {
    t = (e) => {
      return e;
    };
  }
  switch (transaction_type) {
    case "Vente":
      return bienType.length === 1
        ? `${t(pluralOf(bienType[0]))} ${vendu ? t("vendu") : t("à vendre")}`
        : vendu ? t("vendu") : t("à vendre");
    case "Location":
      return bienType.length === 1
        ? `${t(bienType[0])} ${"à louer"}`
        : t("à louer");

    case "Projets Neufs":
      return t("de projets neufs");
    default:
      return t("");
  }
};

export const titleSuffix = (
  region: string,
  province: string,
  commune: string,
  t?: any,
  quartier?: string,
  title_complement?: string,
  address?: any
) => {
  let suffix = "";
  if (quartier && quartier[0]) {
    suffix = ` ${t("à")} ${t(quartier)}`;
  } else if (commune) {
    suffix = ` ${t("à")} ${t(commune)}`;
  } else if (province) {
    suffix = ` ${t("à")} ${t(
      province
        .replace("-Ida -Ou-Tanane", "")
        .replace("Nouaceur", "Bouskoura et Dar Bouazza")
    )}`;
  } else if (region) {
    suffix = ` ${t("à")} ${t(region.replace("Grand ", ""))}`;
  } else {
    suffix = address ? "" : t("partout au Maroc");
  }

  return `${suffix}${title_complement ? t(title_complement) : ""}`;
};
